import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSuppliersApi,
  getSupplierCodeApi,
} from "../../../../apiservice/purchase";
import { getLocationApi } from "../../../../apiservice/setting";
import { saveAccountApi, deleteAccountApi } from "../../../../apiservice/accounts";
import { saveSupplier } from "../../../../services/customer";

// ✅ Fetch all suppliers
export const fetchSuppliersList = createAsyncThunk(
  "suppliers/fetchSuppliersList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getSuppliersApi();
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// ✅ Fetch new supplier code
export const fetchSuppliersCode = createAsyncThunk(
  "suppliers/fetchSuppliersCode",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getSupplierCodeApi();
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// ✅ Create or update supplier
export const createSupplier = createAsyncThunk(
  "suppliers/createSupplier",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveSupplier(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// ✅ Delete supplier
export const deleteSupplier = createAsyncThunk(
  "suppliers/deleteSupplier",
  async (id, { rejectWithValue }) => {
    try {
      const res = await deleteAccountApi({ acc_id: id });
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
